/*************************************************
  1Store — Product dimensions overlay
  Рисует размерные линии (высота / ширина / глубина) прямо по
  габаритам товара на ПЕРВОМ фото галереи карточки товара.

  Данные: data-dims-h / data-dims-w / data-dims-d на ul.l4pr
  (заполняются в main-product-gallery.liquid из метаполей
  custom.augstums_cm / custom.platums_cm / custom.dzilums_cm).

  Координаты краёв товара берутся из расчёта auto-image-fit.js
  (img.dataset.imgfitBox + текущий transform) — линии совпадают
  с реальными краями товара, а не с рамкой картинки.

  Стоимость: ноль сетевых запросов, несколько DOM-элементов.
**************************************************/
(() => {
  const gal = document.querySelector('.m6pr .l4pr[data-dims-h]');
  if (!gal) return;

  const H = parseFloat(String(gal.dataset.dimsH).replace(',', '.'));
  const W = parseFloat(String(gal.dataset.dimsW).replace(',', '.'));
  const D = parseFloat(String(gal.dataset.dimsD || '').replace(',', '.'));
  if (!H || !W) return;

  const fmt = (v) => (Math.round(v * 10) / 10).toString().replace('.', ',') + ' cm';
  const LINE = '#8b929b', LABEL = '#4b5563';

  function firstSlide() {
    const lis = gal.querySelectorAll('li:not(.more)');
    for (const li of lis) {
      if (li.closest('.swiper-pagination-bullets')) continue;
      const img = li.querySelector('img');
      if (img && img.dataset.imgfitBox) return { li, img };
    }
    return null;
  }

  function contentRect(li, img) {
    let box;
    try { box = JSON.parse(img.dataset.imgfitBox); } catch (e) { return null; }
    const ir = img.getBoundingClientRect();   // уже с transform (zoom/dx/dy)
    const lr = li.getBoundingClientRect();
    if (!ir.width || !lr.width || !img.naturalWidth) return null;
    // painted-область object-fit:contain внутри (уже трансформированного) элемента
    const natAspect = img.naturalWidth / img.naturalHeight;
    let pw = ir.width, ph = ir.width / natAspect;
    if (ph > ir.height) { ph = ir.height; pw = ir.height * natAspect; }
    const px = ir.left + (ir.width - pw) / 2;
    const py = ir.top + (ir.height - ph) / 2;
    // рамка товара в координатах li
    return {
      left:   px + (box.cx - box.fw / 2) * pw - lr.left,
      right:  px + (box.cx + box.fw / 2) * pw - lr.left,
      top:    py + (box.cy - box.fh / 2) * ph - lr.top,
      bottom: py + (box.cy + box.fh / 2) * ph - lr.top,
    };
  }

  function el(tag, css) {
    const e = document.createElement(tag);
    e.style.cssText = css;
    return e;
  }

  function draw() {
    const fs = firstSlide();
    if (!fs) return false;
    const { li, img } = fs;
    const r = contentRect(li, img);
    if (!r) return false;
    const liW = li.offsetWidth;

    // Подпись геометрии. Свайп галереи присылает transitionend пачкой, но
    // рамка товара при этом чаще всего та же — тогда рвать и собирать
    // оверлей заново незачем. Сравнение стоит один раз, пересборка — десять
    // узлов и принудительная компоновка.
    const sig = [r.left, r.right, r.top, r.bottom, liW].map(Math.round).join('|');

    let ov = li.querySelector(':scope > .dims-overlay');
    if (ov && ov.dataset.dimsSig === sig) return true;
    if (ov) ov.remove();
    // z-index 20: ссылка фанбокса в галерее имеет z-index 9
    ov = el('div', 'position:absolute;left:0;top:0;right:0;bottom:0;z-index:20;pointer-events:none;font:500 12px/1 sans-serif;');
    ov.className = 'dims-overlay';
    li.style.position = 'relative';

    const tick = 7;
    // --- высота: вертикальная линия слева от товара
    const hx = Math.max(10, r.left - 16);
    ov.appendChild(el('div', `position:absolute;left:${hx}px;top:${r.top}px;width:1px;height:${r.bottom - r.top}px;background:${LINE}`));
    ov.appendChild(el('div', `position:absolute;left:${hx - tick / 2}px;top:${r.top}px;width:${tick}px;height:1px;background:${LINE}`));
    ov.appendChild(el('div', `position:absolute;left:${hx - tick / 2}px;top:${r.bottom}px;width:${tick}px;height:1px;background:${LINE}`));
    const hl = el('div', `position:absolute;left:${hx}px;top:${(r.top + r.bottom) / 2}px;transform:translate(-50%,-50%) rotate(-90deg);background:rgba(255,255,255,.92);padding:2px 7px;border-radius:6px;color:${LABEL};white-space:nowrap`);
    hl.textContent = fmt(H);
    ov.appendChild(hl);

    // --- ширина: горизонтальная линия под товаром
    const wy = Math.min(li.offsetHeight - 10, r.bottom + 14);
    ov.appendChild(el('div', `position:absolute;left:${r.left}px;top:${wy}px;width:${r.right - r.left}px;height:1px;background:${LINE}`));
    ov.appendChild(el('div', `position:absolute;left:${r.left}px;top:${wy - tick / 2}px;width:1px;height:${tick}px;background:${LINE}`));
    ov.appendChild(el('div', `position:absolute;left:${r.right}px;top:${wy - tick / 2}px;width:1px;height:${tick}px;background:${LINE}`));
    const wl = el('div', `position:absolute;left:${(r.left + r.right) / 2}px;top:${wy}px;transform:translate(-50%,-50%);background:rgba(255,255,255,.92);padding:2px 7px;border-radius:6px;color:${LABEL};white-space:nowrap`);
    wl.textContent = fmt(W);
    ov.appendChild(wl);

    // --- глубина: короткая диагональ от правого нижнего угла товара,
    //     подпись — НАД линией и левее, чтобы не вылезать за слайд
    if (D) {
      const len = Math.min(34, liW * 0.08);
      const dx0 = Math.min(liW - 12, r.right + 4);
      const dline = el('div', `position:absolute;left:${dx0}px;top:${r.bottom - len * 0.7}px;width:${len}px;height:1px;background:${LINE};transform:rotate(-35deg);transform-origin:left center`);
      ov.appendChild(dline);
      const dl = el('div', `position:absolute;left:${dx0}px;top:${r.bottom - len * 0.7 - 26}px;background:rgba(255,255,255,.92);padding:2px 7px;border-radius:6px;color:${LABEL};white-space:nowrap`);
      dl.textContent = fmt(D);
      dl.className = 'dims-clamp';
      ov.appendChild(dl);
    }

    ov.dataset.dimsSig = sig;
    li.appendChild(ov);

    // Страховка: подпись глубины не выходит за правый край слайда.
    // Чтение геометрии вынесено в СЛЕДУЮЩИЙ кадр. Сразу после записи в DOM
    // браузер обязан пересчитать раскладку по первому же offsetLeft — и если
    // это происходит внутри обработчика события, пересчёт попадает прямо
    // в задержку отклика. liW измерен ДО записи, второй раз не читаем.
    requestAnimationFrame(() => {
      ov.querySelectorAll('.dims-clamp').forEach((e) => {
        const overflowR = e.offsetLeft + e.offsetWidth - (liW - 4);
        if (overflowR > 0) e.style.left = Math.max(2, e.offsetLeft - overflowR) + 'px';
      });
    });
    return true;
  }

  // Одна отрисовка за кадр, что бы её ни попросило.
  let raf = 0;
  const schedule = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => { raf = 0; draw(); });
  };

  // Ждём, пока auto-image-fit посчитает границы первого фото.
  // Раньше здесь стоял опрос setInterval(…, 300) до 40 раз — до 12 секунд
  // работы уже ПОСЛЕ загрузки страницы, и каждый тик читал геометрию.
  // Касание в эти секунды ждало освобождения потока, а ожидание уходит
  // прямо в INP. Теперь ждём событие: атрибут появился — рисуем один раз.
  if (!draw()) {
    const mo = new MutationObserver(() => { if (draw()) mo.disconnect(); });
    mo.observe(gal, {
      subtree: true, childList: true,
      attributes: true, attributeFilter: ['data-imgfit-box', 'src'],
    });
    // Страховка: если auto-image-fit не отработает вовсе, не наблюдаем вечно.
    setTimeout(() => mo.disconnect(), 15000);
  }

  // перерисовка при смене раскладки и после «досадки» зума
  let rt = null;
  window.addEventListener('resize', () => {
    clearTimeout(rt);
    rt = setTimeout(schedule, 250);
  });
  // Слушатель на самой галерее, а не на всём документе в фазе перехвата:
  // до правки любой переход картинки дёргал draw() синхронно внутри
  // обработчика. Теперь — через кадр и только из галереи.
  gal.addEventListener('transitionend', (e) => {
    if (e.target && e.target.tagName === 'IMG') schedule();
  });
})();